import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BaseHttpService } from '../../services/base-http.service';
import { emailValidation } from '../../shared/utilities';
import { URLS } from '../../shared/url';
import { Response } from '../../models/generated-view-models';
import { ResponseTypeEnum } from '../../models/enums';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
    public email: string;
    public send: boolean;
    public forgotPasswordForm: FormGroup;
    public err_message: string;

    constructor(
        private formBuilder: FormBuilder,
        private http: BaseHttpService) { }

    ngOnInit() {
        this.buildForm();
    }

    public buildForm = (): void => {
        this.forgotPasswordForm = this.formBuilder.group({
            'email': ['', [Validators.required, emailValidation()]]
        });
    }

    public sendEmail = (): void => {
        this.http.Post(`${URLS.sendSecureLink}/${this.forgotPasswordForm.get('email').value}`, null, ResponseTypeEnum.Full).subscribe((res: Response<boolean>) => {
            if (res.success) {
                this.send = true;
            } else {
                this.err_message = res.userFriendlyErrorMessage || 'Something went wrong.';
            }
        })
    }

}
